export default "__VITE_ASSET__DrL7kXML__"